export default __webpack_public_path__ + "static/media/zendesk.7142fed0.svg";